/* eslint-disable max-statements */
import React, { useEffect, useState } from 'react';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { MultiSelect } from 'primereact/multiselect';
import { toast } from 'react-toastify';
import {
    useGetAllCountriesQuery,
} from '../../../pages/correctiveActions/correctiveActionsSlice';
import {
    useGetHcApproverConfigsQuery,
    useGetJobCodesQuery,
    useGetHcApproverEmployeeQuery,
    useInsertCaHcApproversMutation
} from './HcDashboard.slice';
import { Country } from '../type';

interface HcDashboardPropTypes {
    selectedCountry: Country,
    isHCEdit: boolean,
    isHCConfig: boolean,
    editedJobCodes?: any,
    setSelectedCountry: (e: Country) => void;
    setActiveIndex: (e: number) => void;
    setIsHCEdit: (e: boolean) => void;
    setIsHCConfig: (e: boolean) => void;
    setEditedJobCodes: (e: string[]) => void;
}

export const HcDashboard = ({
    selectedCountry,
    isHCEdit,
    isHCConfig,
    editedJobCodes,
    setSelectedCountry,
    setActiveIndex,
    setIsHCEdit,
    setIsHCConfig,
    setEditedJobCodes
}: HcDashboardPropTypes) => {
    const [selectedJobCodes, setSelectedJobCodes] = useState([]);
    const [selectedEmpRecord, setSelectedEmpRecord] = useState([]);
    const [countryList, setCountryList] = useState([]);
    const [jobCodesList, setJobCodesList] = useState([]);
    const [hcApproverEmpRecords, setHcApproverEmpRecords] = useState([]);
    const [hcConfigData, setHcConfigData] = useState([]);
    const [saveBtnDisable, setSaveBtnDisable] = useState<boolean>(true);
    const [selectedJobCodesString, setSelectedJobCodesString] = useState<string[]>([]);
    const { data: allCountries } = useGetAllCountriesQuery();
    const { data: hcApproverConfigsData } = useGetHcApproverConfigsQuery({
        countryId: selectedCountry?.country_id,
    });
    const { data: jobcodesData } = useGetJobCodesQuery();
    const { data: hcApproverEmpData } = useGetHcApproverEmployeeQuery({
        countryId: selectedCountry?.country_id,
        jobCodes: selectedJobCodesString,
    },
        {
            skip: selectedJobCodesString.length === 0 || selectedCountry?.country_id === 0,
        });

    const [insertCaHcApprovers] = useInsertCaHcApproversMutation();

    useEffect(() => {
        setJobCodesList(jobcodesData?.data);
    }, [jobcodesData])
    useEffect(() => {
        setCountryList(allCountries?.data);
    }, [allCountries])

    useEffect(() => {
        setHcApproverEmpRecords(hcApproverEmpData?.data);
    }, [hcApproverEmpData])
    useEffect(() => {
        setHcConfigData(hcApproverConfigsData?.data)
    }, [hcApproverConfigsData])

    useEffect(() => {
        const preSelected: any = hcApproverEmpRecords?.filter((item: any) => item.isApprover);
        setSelectedEmpRecord(preSelected);

    }, [hcApproverEmpRecords])

    useEffect(() => {
        if (selectedCountry?.country_id !== 0 && selectedEmpRecord?.length > 0) {
            setSaveBtnDisable(false);
        }
        else {
            setSaveBtnDisable(true);
        }

    }, [selectedEmpRecord]);

    useEffect(() => {
        if (isHCConfig) {
            const countryList: any = [... (allCountries ? allCountries.data : [])];
            hcApproverConfigsData?.data.forEach((config: any) => {
                const index = countryList.findIndex((country: any) => country.country_id === config.country_id);
                countryList.splice(index, 1);
            });
            setCountryList(countryList);
        }

    }, [isHCConfig])

    useEffect(() => {
        if (isHCEdit) {
            setSelectedJobCodes(editedJobCodes);
            const codeString: string[] = [];
            editedJobCodes?.forEach((code: any) => {
                codeString.push(code.job_code);
            })
            setSelectedJobCodesString(codeString.length > 0 ? codeString : []);
        }

    }, [isHCEdit])


    const handleOnCountryChange = (e: any) => {
        const selectedCountry = allCountries?.data?.find((country: any) => country.country_id === e.target.value);
        setSelectedCountry(selectedCountry);
    }

    const resetFilter = () => {
        setSelectedCountry({ 'country_id': 0, 'country_name': '' });
        setSelectedEmpRecord([]);
        setSelectedJobCodes([]);
        setSelectedJobCodesString([]);
        setEditedJobCodes([]);
    }


    const handleEditClick = (rowData: any) => {
        const selectedCountry = {
            'country_id': rowData?.country_id,
            'country_name': rowData.country_name
        }
        setSelectedCountry(selectedCountry);

        const onEditselectCodes: string[] = [];
        const editjobCodes = rowData.hc_job_codes.split(',');
        editjobCodes.forEach((codeString: string) => {
            const codeFound = jobcodesData?.data.filter((allcode: any) => allcode.job_code === codeString)
            if (codeFound?.length > 0) {
                onEditselectCodes.push(codeFound[0]);
            }
        });

        setEditedJobCodes(onEditselectCodes);
        setIsHCEdit(true);
        setIsHCConfig(false);
        setActiveIndex(1);
    }

    const editTemplate = (rowData: any) => {
        return (
            <div style={{ textAlign: "center" }}>
                <Button
                    type="button"
                    onClick={() => {
                        handleEditClick(rowData)
                    }}
                    icon="pi pi-pencil"
                    style={{ background: "transparent", border: "#CECECD 1px solid", color: "#3F5765" }}
                />
            </div>
        );

    }

    const handleNewConfigBtnClick = () => {
        setIsHCEdit(false);
        setIsHCConfig(true);
        setActiveIndex(1);
    }

    const jobcodesTemplate = (rowData: any) => {
        const jobCodeArray = rowData?.hc_job_codes.split(',');
        let jobCodeDesc = '';
        jobCodeArray.forEach((code: any, index: number) => {
            const getJobcode = jobcodesData?.data.filter((rec: any) => rec.job_code.toLowerCase() === code.toLowerCase())
            if (getJobcode?.length > 0) {
                if ((index === jobCodeArray.length - 1))
                    jobCodeDesc += getJobcode[0].job_title_name;
                else
                    jobCodeDesc += `${getJobcode[0].job_title_name}, `
            }
        });
        return (
            <span>{`${jobCodeDesc}`}</span>
        )
    }
    const handleJobCodeChange = (e: any) => {
        const jcodes: string[] = [];
        e?.value.forEach((code: any) => {
            const codeName = code?.job_code;
            jcodes.push(codeName);
        });
        setSelectedJobCodesString(jcodes.length > 0 ? jcodes : []);
        setSelectedJobCodes(e.value);
    }
    const InsertCaHcApprovers = (caHcApproversPayload: any) => {
        insertCaHcApprovers(caHcApproversPayload)
            .unwrap()
            .then((data: any) => {
                if (data?.data) {
                    resetFilter();
                    if (isHCEdit === true)
                        setActiveIndex(0);
                    setIsHCEdit(false);
                    return isHCEdit !== true ? toast.success('Created HC approver Successfully') : toast.success('Updated HC approver Successfully');
                }
                return isHCEdit !== true ? toast.error('Creating HC approver failed') : toast.error('Updating HC approver failed');
            });
    }
    const handleSaveUpdateBtnClick = () => {
        const selectedEmpNumber: string[] = [];
        selectedEmpRecord?.forEach((emp: any) => {
            selectedEmpNumber.push(emp.employee_number.toString());
        })
        const caHcApproversPayload = {
            'country_id': selectedCountry?.country_id,
            approvers: selectedEmpNumber,
            jobCodes: selectedJobCodesString
        }
        InsertCaHcApprovers(caHcApproversPayload);
    }

    return (
        <>
            <div className="row mt-4">
                <div className="col-md-2">
                    <h6 style={{ fontWeight: '600', fontSize: '16px', }}>
                        Country
                    </h6>
                    <Dropdown
                        disabled={isHCEdit}
                        id='countrydd'
                        placeholder="Select a Country"
                        className="custom-dropdown w-200"
                        options={countryList}
                        optionValue={'country_id'}
                        optionLabel={'country_name'}
                        value={selectedCountry?.country_id}
                        onChange={handleOnCountryChange}
                    />
                </div>
                {(isHCConfig || isHCEdit) ?
                    <>
                        <div className="col-md-2">
                            <h6 style={{ fontWeight: '600', fontSize: '16px', }}>
                                Job Code
                            </h6>
                            <MultiSelect
                                value={selectedJobCodes}
                                onChange={handleJobCodeChange}
                                options={jobCodesList}
                                optionLabel="job_code"
                                placeholder="Select Job Codes"
                                maxSelectedLabels={5}
                                className="custom-dropdown"
                            />
                        </div>
                        <div className="col-md-3">&nbsp;</div>
                    </>
                    :
                    <>
                        <div className="col-md-7">&nbsp;</div>
                        <div className="col-md-3">
                            <Button
                                type="button"
                                onClick={handleNewConfigBtnClick}
                                label="Configure New HC Approver"
                                className="btn-primary"
                            />
                        </div>
                    </>
                }


            </div>
            <div className='row mt-4'>
                {(isHCConfig || isHCEdit) && (
                    <DataTable
                        value={hcApproverEmpRecords}
                        className="ca-dashboard"
                        rows={5}
                        paginator={hcApproverEmpRecords?.length > 5}
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        rowsPerPageOptions={[5, 10, 25, 50]}
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                        selection={selectedEmpRecord}
                        onSelectionChange={(e) => { setSelectedEmpRecord(e.value) }}
                    >
                        <Column
                            selectionMode="multiple"
                            headerStyle={{ width: '1rem' }}
                            bodyStyle={{ width: '1rem' }}

                        />
                        <Column
                            style={{ maxWidth: '35px' }}
                            header="Employee"
                            field="employee_name"
                            sortable
                            sortField="employee_name"
                        />
                        <Column
                            style={{ maxWidth: '80px' }}
                            header="Role"
                            field="job_title_name"
                            sortable
                            sortField="job_title_name"
                        />
                    </DataTable>
                )}
                {(!isHCConfig && !isHCEdit) && (
                    <DataTable
                        value={hcConfigData}
                        className="ca-dashboard"
                        rows={5}
                        paginator={hcConfigData?.length > 5}
                        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                        rowsPerPageOptions={[5, 10, 25, 50]}
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    >
                        <Column
                            style={{ maxWidth: '35px' }}
                            header="Country"
                            field="country_name"
                            sortable
                            sortField="country_name"
                        />
                        <Column
                            style={{ maxWidth: '80px' }}
                            header="Job Codes"
                            sortable
                            sortField="hc_job_codes"
                            body={jobcodesTemplate}
                        />
                        <Column
                            body={editTemplate}
                        />
                    </DataTable>
                )}
            </div>
            {
                (isHCConfig || isHCEdit) &&
                (<div className='row mt-4'>
                    <div className='col-md-8'> {isHCConfig}
                        {isHCEdit}</div>
                    <div className="col-md-2">
                        <Button
                            className="btn-secondary"
                            onClick={() => {
                                resetFilter();
                                setIsHCEdit(false);
                                setIsHCConfig(false);
                                setActiveIndex(0);
                            }
                            }
                            label={"Cancel"}
                        />
                    </div>
                    {
                        (isHCConfig || isHCEdit) &&
                        <div className="col-md-2">
                            <Button
                                disabled={saveBtnDisable}
                                className="btn-primary"
                                onClick={handleSaveUpdateBtnClick}
                                label={!isHCEdit ? "Save" : "Update"}
                            />
                        </div>
                    }
                </div>)
            }
        </>
    );
};
